import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const ORDER_REQUEST = 'sherrinford/Project/list/ORDER_REQUEST'
export const ORDER_SUCCESS = 'sherrinford/Project/list/ORDER_SUCCESS'
export const ORDER_ERROR = 'sherrinford/Project/list/ORDER_ERROR'

export const PROJECT_STATUS = 'sherrinford/Project/list/PROJECT_STATUS'
export const PROJECT_COUNTRY = 'sherrinford/Project/list/PROJECT_COUNTRY'
export const SORT_BY = 'sherrinford/Project/list/SORT_BY'
export const IS_ORGANIC_ONLY = 'sherrinford/Project/list/IS_ORGANIC_ONLY'

export const SEARCH_PROJECT_NAME = 'sherrinford/Project/list/SEARCH_PROJECT_NAME'

export const IS_LOADING = 'sherrinford/Project/list/IS_LOADING'
export const DATA = 'sherrinford/Project/list/DATA'

export const SET_IS_MANAGED_ONLY = 'sherrinford/Project/list/SET_IS_MANAGED_ONLY'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  isLoading: false,
  isError: false,
  errorMessage: '',

  projectStatus: '',
  projectCountry: '',
  searchProjectBrand: '',
  sortBy: 'createdAt',
  isOrganicOnly: false,
  isManagedOnly: false,

  orderStatus: {
    invitationSent: {
      status: 0,
      label: 'Invitation Sent',
    },
    creatorResponded: {
      status: 1,
      label: 'Invitation Sent',
    },
    quotationNeeded: {
      status: 2,
      label: 'Quotation Needed',
    },
    projectOrderNeeded: {
      status: 3,
      label: 'Project Order Needed',
    },
    invoiceNeeded: {
      status: 4,
      label: 'Invoice Needed',
    },
    paymentConfirmation: {
      status: 5,
      label: 'Payment Confirmation',
    },
    ready: {
      status: 6,
      label: 'Ready',
    },
    cancelled: {
      status: 7,
      label: 'Cancelled',
    },
  },
}

export default createReducer(initialState, {
  [ORDER_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PROJECT_STATUS]: (state, data) => ({
    ...state,
    projectStatus: data,
  }),
  [PROJECT_COUNTRY]: (state, data) => ({
    ...state,
    projectCountry: data,
  }),
  [SORT_BY]: (state, data) => ({
    ...state,
    sortBy: data,
  }),
  [IS_ORGANIC_ONLY]: state => ({
    ...state,
    isOrganicOnly: !state.isOrganicOnly,
  }),
  [ORDER_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [ORDER_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [SEARCH_PROJECT_NAME]: (state, data) => ({
    ...state,
    searchProjectBrand: data,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),

  [SET_IS_MANAGED_ONLY]: (state, data) => ({
    ...state,
    isManagedOnly: data,
  }),
})

export const setprojectStatusList = data => ({
  type: [PROJECT_STATUS],
  payload: data,
})
export const setprojectCountryList = data => ({
  type: [PROJECT_COUNTRY],
  payload: data,
})

export const setSortBy = data => ({
  type: [SORT_BY],
  payload: data,
})

export const setIsOrganicOnly = () => ({
  type: [IS_ORGANIC_ONLY],
})

export const projectInput = data => ({
  type: [SEARCH_PROJECT_NAME],
  payload: data,
})

export const getProjects = (qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [ORDER_REQUEST, ORDER_SUCCESS, ORDER_ERROR],
    shuttle: {
      method: 'GET',
      path: '/order',
      authorization: `${token}`,
      qs,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setIsManagedOnly = data => ({
  type: [SET_IS_MANAGED_ONLY],
  payload: data,
})

export const submitFilters = () => (dispatch, getState) => {
  const {
      searchProjectBrand,
      projectStatus,
      projectCountry,
      sortBy,
      isOrganicOnly,
      isManagedOnly,
    } = getState().ProjectList

  const qs = {
    sort: `${sortBy} DESC`,
    skip: 0,
    limit: 10,
    where: {
      or: [
          { name: { like: `%${searchProjectBrand}%` } },
          { brand: { like: `%${searchProjectBrand}%` } },
          { firstName: { like: `%${searchProjectBrand}%` } },
          { email: { like: `${searchProjectBrand}%` } },
      ],
    },
  }

  if (isOrganicOnly) {
    qs.where.isOrganic = true
  }
  if (searchProjectBrand === qs.where.name) {
    qs.where.name = searchProjectBrand
  } else if (searchProjectBrand === qs.where.brand) {
    qs.where.brand = searchProjectBrand
  }

  if (projectStatus) {
    qs.where.status = projectStatus
  }
  if (projectCountry) {
    qs.where.country = projectCountry
  }

  if (isManagedOnly) {
    qs.where.isManaged = true
  }

  dispatch(getProjects(qs))
}
